//@ts-check
import React from 'react';
import LogoEngage from './Logo/Engage.svg';
var logoStyles = {
  maxHeight: 100,
  maxWidth: 400,
  width: 36,
  height: 36,
  color: 'white'
};
/**
 * @param {import('./types').IconLogoProps} props
 */

function IconLogo(_ref) {
  var src = _ref.src,
      alt = _ref.alt;
  return React.createElement("img", {
    src: src,
    style: logoStyles,
    alt: alt
  });
}

IconLogo.defaultProps = {
  src: LogoEngage,
  alt: 'Ecrion'
};
export default IconLogo;